import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";
import { Box } from "@mui/material";
import ImmigrationImg1 from "../../../../../src/asset/internationalRelationTemp/collabrativeReasearch.jpg"
// const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
// const ImmigrationImg1 = imageBaseUrl +"International-Relation/IndiaPage/takshaInsti.png";

const Collaborative = () => {
  return (
    <Box id='collaborative-research-seminars'>
      <MainContainer
        dir="column-reverse"
        color={"#EFFDFF"}
        com1={<ImageContainer img={ImmigrationImg1} />}
        com2={
          <ContentContainer
            Header={<Header content={"Collaborative Research & Seminars "} />}
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  <>
                  At <b>Taksheela Institute of Education</b>, we promote <b>academic excellence and global collaboration</b> through research partnerships, seminars, and expert-led discussions. Our initiatives bridge the gap between academia and industry, equipping students with <b>cutting-edge knowledge and global perspectives.</b>

                    <br /><br /> 
                    We collaborate with <b>leading universities and industry experts</b> to foster <b>innovative research and interdisciplinary learning</b>. Our <b>seminars, workshops, and guest lectures</b> provide valuable insights from top scholars and professionals, keeping students informed about <b>emerging trends and career opportunities</b>. Through <b>student and faculty exchange programs</b>, we offer <b>international academic exposure</b>, enhancing research capabilities and professional growth. At <b> Taksheela</b>, we empower students with the skills, knowledge, and networks to excel in a <b>global academic and professional landscape</b>.
                  
               </> }
              />
            }
          />
        }
      />
    </Box>
  );
};
export default Collaborative;
